/** HTTP status from Angular HttpClient or wrapped API errors. */
export function getApiErrorStatus(error: unknown): number | undefined {
  const e = error as {
    status?: number;
    error?: { status?: number };
    response?: { status?: number };
  };
  return e?.status ?? e?.error?.status ?? e?.response?.status;
}

/** Prefer RFC 7807 `detail`, then `title`, then message. */
export function getApiErrorDetail(
  error: unknown,
  fallback = 'An error occurred',
): string {
  const e = error as {
    error?: { detail?: string; title?: string; message?: string };
    detail?: string;
    title?: string;
    message?: string;
    response?: { data?: { detail?: string }; detail?: string };
  };
  return (
    e?.error?.detail ??
    e?.detail ??
    e?.response?.data?.detail ??
    e?.response?.detail ??
    e?.error?.title ??
    e?.title ??
    e?.error?.message ??
    e?.message ??
    fallback
  );
}
